import { t as translateDate } from './translate-date.js';
import { p as padDateString } from './pad-date-string.js';
import './index2.js';

/**
 * **BookVisit - Nozio v2**
 *
 * @exports bs_436
 * @category engines
 */
function factory({ window, document, thn }) {
    const engine = {};
    let refreshPrice;
    /**
     * @memberOf module:bs_436
     * @see {@link language_check}
     *
     * @param {object} ctx - The context object.
     */
    engine.languageCheck = function languageCheck(ctx) {
        return new Promise(function (resolve, reject) {
            let lang = document.querySelector('.bv-language img').src.split('/').pop().slice(0, 2);
            lang = lang === 'nb' ? 'no' : lang;
            if (lang && ctx.langs.test(lang)) {
                resolve(lang);
                return;
            }
            reject('no_language');
        });
    };
    /**
       * @memberOf module:bs_436
       * @see {@link onStateChange}
       *
       * @param {object} ctx - The context object.
       */
    engine.onStateChange = thn.debounce(function (ctx) {
        thn.pageCheck();
    }, 400);
    /**
       * @memberOf module:bs_436
       * @see {@link is_user_logged}
       *
       * @param {object} ctx - The context object.
       */
    engine.isUserLogged = function isUserLogged(ctx) {
        const isLogged = false;
        return isLogged;
    };
    /**
   * @memberOf module:bs_436
   * @see {@link onHashChange}
   *
   * @param {object} ctx - The context object.
   */
    engine.onHashChange = thn.debounce(thn.pageCheck, 600);
    /**
     * @memberOf module:bs_436
     * @this thn.widgets.price
     * @see {@link Price#observe_dom}
     *
     * @param {object} ctx - The context object.
     */
    engine.priceObserveDom = function priceObserveDom(ctx) {
        const resultContainer = document.querySelector('.book-section-accommodation, .book-section-package');
        if (resultContainer) {
            refreshPrice = thn.debounce(() => {
                const loading = !thn.isVisible(document.querySelector('#outer_div'));
                if (!loading) {
                    thn.widgets.price.refresh();
                }
            }, 600);
            thn.observeDom(resultContainer, refreshPrice, {
                childList: true,
                subtree: true,
                attributes: false,
            });
            thn.pageUnload(() => {
                refreshPrice.cancel();
                thn.stopObserveDom(resultContainer, refreshPrice);
                refreshPrice = null;
            });
        }
    };
    /**
       * @memberOf module:bs_436
       * @this thn.widgets.price
       * @see {@link Price#set_data}
       *
       * @param {object} ctx - The context object.
       */
    engine.priceParseData_v1 = function priceParseData_v1(ctx) {
        const widgetData = {};
        const isEliteHotel = thn.data.accountUserId === 1035627;
        let totalAdults = 0;
        let totalChildren = 0;
        let totalPrice = 0;
        let nights;
        if (!thn.isVisible(document.querySelector('#outer_div'))) {
            return widgetData;
        }
        const searchResult = JSON.parse(sessionStorage.getItem('bv_searchresult'));
        // Dates
        if (searchResult) {
            const dateBegin = thn.dateToString(searchResult.accommodationSearch?.arrivalDate);
            const dateEnd = thn.dateToString(thn.addDays(dateBegin, searchResult.accommodationSearch?.numberOfNights));
            if (dateBegin && dateEnd) {
                widgetData.dateBegin = dateBegin;
                widgetData.dateEnd = dateEnd;
                nights = searchResult.accommodationSearch?.numberOfNights || thn.daysBetween(widgetData.dateBegin, widgetData.dateEnd);
            }
            // Guests, Adults & Children
            widgetData.roomsDispo = [];
            const rooms = searchResult.accommodationSearch?.roomConfigs;
            if (!thn.empty(rooms)) {
                for (let i = 0; i < rooms.length; i += 1) {
                    const adults = thn.parseNumber(rooms[i].adults) || 2;
                    const children = thn.parseNumber(rooms[i].childAges?.length) || 0;
                    const roomInfo = {
                        adults: adults,
                        children: children,
                        childrenAges: [],
                        price: 0,
                    };
                    for (let e = 0; e < roomInfo.children; e += 1) {
                        roomInfo.childrenAges.push(rooms[i].childAges[e]);
                    }
                    const eliteRates = [...document.querySelectorAll('[style*="grid-area"] div')].filter((rate) => rate.querySelector('[style*="text-transform"]'));
                    const availableEliteRates = eliteRates.filter((availableEliteRate) => thn.parseNumber(availableEliteRate.querySelector('[style*="text-transform"]')?.textContent) >= rooms[i]?.adults);
                    const eliteMatchedPrices = availableEliteRates.map((matchedPrice) => thn.parseNumber(matchedPrice.querySelector('p')?.textContent));
                    const roomsRates = searchResult.roomsResult
                        .map((roomResult) => !thn.empty(roomResult.rateAlternatives)
                        && [...roomResult.rateAlternatives]
                            .map((roomDetail) => roomDetail.ratesPerRoomConfig)[0])
                        .filter(Boolean)
                        .flatMap((innerArray) => innerArray.map((set) => ({ ...set })));
                    const availableRooms = roomsRates
                        .filter((rate) => rate.roomConfig?.adults >= rooms[i].adults);
                    const availablePrices = isEliteHotel
                        ? eliteMatchedPrices
                        : availableRooms.map((availableRoom) => availableRoom.totalPrice?.displayPrice);
                    const matchedPrices = availablePrices.filter(Boolean);
                    const dormitoryRooms = thn.data.propertyId === 1033561
                        && !thn.empty(roomsRates)
                        && thn.empty(availableRooms);
                    const pricesPerBed = roomsRates
                        .map((rate) => (rate.totalPrice?.displayPrice || 0) * rooms[i].adults);
                    const prices = dormitoryRooms ? pricesPerBed : matchedPrices;
                    const price = !thn.empty(prices) && Math.min(...prices);
                    roomInfo.price = price && price / nights;
                    widgetData.roomsDispo.push(roomInfo);
                    // Store number of guests
                    totalAdults += adults;
                    totalChildren += children;
                    totalPrice += roomInfo.price;
                }
            }
            widgetData.adults = totalAdults || 2;
            widgetData.children = totalChildren || 0;
            widgetData.guests = widgetData.adults + widgetData.children;
        }
        // Prices & Currency || No Rooms
        const currency = searchResult?.currencyCode || document.querySelector('.cb-js-codepicker-trigger')?.innerText;
        const checkPrices = widgetData.roomsDispo?.map((room) => room?.price).filter(Boolean);
        const noAvailability = thn.empty(checkPrices);
        if (!thn.empty(totalPrice) && currency && nights) {
            widgetData.price = totalPrice;
            widgetData.currency = currency;
            widgetData.set = true;
        }
        else if (noAvailability && nights) {
            widgetData.noRooms = true;
        }
        return widgetData;
    };
    /**
       * @memberOf module:bs_436
       * @this thn.widgets.price
       * @see {@link Price#set_data}
       *
       * @param {object} ctx - The context object.
       */
    engine.priceParseData_v2 = function priceParseData_v2(ctx) {
        const widgetData = {};
        // Dates
        const checkinYear = thn.parseUrlParameter('year');
        const checkinMonth = thn.parseUrlParameter('month');
        const checkinDay = thn.parseUrlParameter('day');
        const dateBeginParsed = `${checkinYear}/${checkinMonth}/${checkinDay}`;
        const dateBegin = padDateString(dateBeginParsed);
        const nights = thn.parseUrlParameter('staylength');
        const dateEnd = nights && thn.dateToString(thn.addDays(dateBeginParsed, nights));
        if (!dateBegin || !dateEnd) {
            return widgetData;
        }
        widgetData.dateBegin = dateBegin;
        widgetData.dateEnd = dateEnd;
        // Guests, Adults & Children
        widgetData.roomsDispo = [];
        const guests = thn.parseUrlParameter('roomconfig')?.split('|');
        guests.forEach((occupancy) => {
            const guest = occupancy.split('_');
            const room = {
                adults: thn.parseNumber(guest[0]),
                children: thn.parseNumber(guest.length - 1),
                childrenAges: guest.length > 1 ? guest.slice(1).map((age) => thn.parseNumber(age)) : [],
            };
            widgetData.roomsDispo.push(room);
        });
        // when this selector is on the page, only appears data from half of the rooms, we cannot collect the case of multi-rooms.
        const selector = document.querySelector('div[data-testid="room_card_tile_group"]');
        if (selector && window.innerWidth > 1200) {
            if (guests.length > 1) {
                return widgetData;
            }
            // If we only have one room we can collect the data from covers
            const prices = [...document.querySelectorAll('div[data-testid="tile_base"] div.slideIn > p > span:first-child')];
            const finalPrices = prices?.map((price) => thn.parseNumber(price.textContent)).filter(Boolean);
            widgetData.price = Math.min(...finalPrices) / nights;
            const currency = thn.parseCurrency(prices?.[0]?.textContent);
            widgetData.currency = currency;
        }
        else {
            // We collect each price, with the guests that belongs to it
            const priceAndGuests = [...document.querySelectorAll('.rate_alt_outer > div:last-child > div:not([aria-haspopup="dialog"]), div.mantine-Skeleton-root > div > div > div:last-child > div:has(p)')]?.map((price) => {
                const prices = thn.parseNumber(price.querySelector('p:last-of-type')?.textContent);
                let guestsRoom = price.querySelector(':scope > div:last-child');
                if (!guestsRoom) {
                    guestsRoom = price.nextElementSibling;
                }
                let guestsPlus = {
                    adults: 0,
                    children: 0,
                    childrenAges: [],
                };
                let adults = 0;
                let children = 0;
                let childrenAges = [];
                const checkGuests = guestsRoom?.querySelector('span:first-child')?.textContent?.split(',');
                if (checkGuests.length !== 1) {
                    adults = thn.parseNumber(checkGuests[0]);
                    children = thn.parseNumber(checkGuests[1]);
                    childrenAges = guestsRoom?.querySelector('span:first-child')?.textContent?.split('(')?.[1]?.split(',')?.map((ages) => thn.parseNumber(ages));
                }
                else {
                    adults = thn.parseNumber(guestsRoom?.querySelector('span:first-child')?.textContent);
                    children = thn.parseNumber(guestsRoom?.querySelector('span:nth-child(2)')?.textContent);
                    childrenAges = guestsRoom?.querySelector('span:nth-child(3)')?.textContent?.split(',')?.map((ages) => thn.parseNumber(ages));
                }
                guestsPlus = {
                    adults: adults || 2,
                    children: children || 0,
                    childrenAges: childrenAges || [],
                };
                const finalPriceAndGuests = {
                    price: prices,
                    guests: guestsPlus,
                };
                return finalPriceAndGuests;
            }).filter(Boolean);
            // To calculate the final price, we take the minimum price of each room searched
            let totalPrice = 0;
            for (let i = 0; i < widgetData.roomsDispo.length; i += 1) {
                const rooms = priceAndGuests.filter((occupancy) => occupancy.guests.adults === widgetData.roomsDispo[i].adults && occupancy.guests.children === widgetData.roomsDispo[i].children && occupancy.guests.childrenAges?.sort()?.toString() === widgetData.roomsDispo[i].childrenAges?.sort()?.toString());
                const prices = Array.isArray(rooms) && rooms.length > 0 ? rooms.map((room) => room.price).filter(Boolean) : [];
                const price = prices.length !== 0 ? Math.min(...prices) : null;
                if (!price) {
                    widgetData.noRooms = true;
                    return widgetData;
                }
                totalPrice += price;
            }
            widgetData.price = totalPrice;
            const currency = thn.parseCurrency(document.querySelector('.rate_alt_outer > div:last-child > div > p:last-of-type, .rate_tile > div:last-child > div:first-child > p:last-of-type')?.textContent);
            widgetData.currency = currency;
            const noAvailability = window.location.pathname.match(/no-availability/);
            if (totalPrice > 0 && currency && nights) {
                widgetData.price = totalPrice / nights;
                widgetData.currency = currency;
            }
            else if (noAvailability) {
                widgetData.noRooms = true;
            }
        }
        return widgetData;
    };
    /**
       * @memberOf module:bs_436
       * @this thn.widgets.booking
       * @see {@link Booking#set_data}
       *
       * @param {object} ctx - The context object.
       */
    engine.bookingParseData = function bookingParseData(ctx) {
        const widgetData = {};
        const booking = window.booking;
        if (booking && booking.BookingCode) {
            widgetData.bookingId = booking.BookingCode;
        }
        if (!widgetData.bookingId) {
            widgetData.bookingId = thn.parseUrlParameter('bookingcode') || thn.dataLayerHelper.get('transaction_id') || document.querySelector('b.bv-txt-required')?.textContent?.trim();
        }
        const currency = thn.dataLayerHelper.get('currency') || thn.parseCurrency(document.querySelector('.bv-value')?.textContent);
        const total = thn.dataLayerHelper.get('value') || thn.parseNumber(booking?.TotalAmount);
        widgetData.price = total;
        widgetData.currency = currency;
        // dates
        if (booking && booking.Products && booking.Products.length && booking.Products[0].Start) {
            widgetData.dateBegin = booking.Products[0].Start.replace(/(\d+)\D+(\d+)\D+(\d+).*/, '$1/$2/$3');
        }
        if (booking && booking.Products && booking.Products.length && booking.Products[0].End) {
            widgetData.dateEnd = booking.Products[0].End.replace(/(\d+)\D+(\d+)\D+(\d+).*/, '$1/$2/$3');
        }
        if (!widgetData.dateEnd && widgetData.dateBegin) {
            widgetData.dateBegin = translateDate(document.querySelector('.dWanAp .ldRAti > p:nth-child(2)')?.textContent);
            widgetData.dateEnd = translateDate(document.querySelector('.dWanAp .ldRAti > p:nth-child(4)')?.textContent);
        }
        widgetData.promocode = document.querySelector('input[name="PromoCode"]')?.value;
        return widgetData;
    };
    return engine;
}

export { factory };
